module.exports = __webpack_public_path__ + "media/images/flags/SV-af46f485553a3e7bb172cf18a0d3bc33.svg";